import styled from "styled-components";

export const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 2px solid #ccc;
  width: 75%;
`;

export const Tab = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  color: ${(props) => (props.active ? "#e30016" : "#666")};
  font-weight: ${(props) => (props.active ? "bold" : "normal")};
  border-bottom: ${(props) => (props.active ? "3px solid #e30016" : "none")};
`;

export const Icon = styled.div`
  font-size: 24px;
  margin-bottom: 5px;
`;

export const TabText = styled.div`
  font-size: 14px;
  text-transform: uppercase;
`;